<template>
  <div class="form-group">
    <multiselect v-model="selectedRequirements"
                 :options="requirements"
                 :multiple="true"
                 :custom-label="customRequirementLabel"
                 :close-on-select="true"
                 :clear-on-select="false"
                 :hide-selected="true"
                 :max="20"
                 placeholder="Link requirements to content"
                 track-by="requirement_id">
    </multiselect>
  </div>
</template>

<script>
  import dialogMixin from '@/mixins/dialog'
  import requirementModalMixin from '@/mixins/requirementModal'
  import utilsMixin from '@/mixins/utils'
  export default {
    data () {
      return {
        requirements: [],
        selectedRequirements: []
      }
    },
    created () {
      this.getRequirements()
    },
    mixins: [dialogMixin, requirementModalMixin, utilsMixin],
    methods: {
      bindButton () {
        window.AP.require(['confluence', 'dialog'], (confluence, dialog) => {
          confluence.getMacroData(macroParams => {
            if (macroParams && macroParams.requirementIds && macroParams.requirementIds.length > 0) {
              const requirementIdNumbers = macroParams.requirementIds.split(',').map(s => Number(s))
              this.selectedRequirements = this.requirements.filter(r => requirementIdNumbers.includes(r.requirement_id))
            }
          })
          dialog.getButton('submit').bind(target => {
            confluence.saveMacro({'requirementIds': this.selectedRequirements.map(s => s.requirement_id.toString()).join(',')})
            confluence.closeMacroEditor()
            return true
          })
        })
      },
      getRequirements () {
        this.$http.get(
          '/api/requirement/lite'
        ).then(response => {
          this.requirements = response.data.requirements
          this.bindButton()
        }, response => {
          console.log('error')
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ConfluenceInsertRequirementsMacroEditorView.vue?4f3efa44